const collapseTrigger = $(".collapse-repeater .item-head");

collapseTrigger.on("click", function () {
    const windowWidth = $(window).outerWidth();
    const headerHeight = $(".main-header").outerHeight();

    const currentRepeaterNumber = $(this).closest(".collapse-repeater").data("repeater");
    const currentSection = $(".collapse-section-" + currentRepeaterNumber);
    const currentContentId = $(this).data("content");

    const currentContent = $(".item-content[data-content='" + currentContentId + "']");
    const allContent = currentSection.find(".item-content");
    const currentTrigger = $(this);
    const allTriggers = currentSection.find(".item-head");

    if (!currentTrigger.hasClass("-active")) {
        allTriggers.removeClass("-active");
        currentTrigger.addClass("-active");
        if (windowWidth < 1440) {
            allContent.slideUp("200");
            currentContent.slideDown("200");
        } else {
            allContent.hide();
            currentContent.show();
        }
        if (windowWidth < 768) {
            setTimeout(function () {
                $('html,body').animate({
                    scrollTop: currentTrigger.offset().top - headerHeight - 15
                }, 300);
            }, 400);
        }
    } else {
        if (windowWidth < 1440) {
            allTriggers.removeClass("-active");
            allContent.slideUp("200");
        }
    }
});